/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createClone } from '../../factoriesAny.js';
export var cloneDependencies = {
  typedDependencies: typedDependencies,
  createClone: createClone
};